import {defineStore, Pinia} from 'pinia';
import {AppContextInstance, ContextDefault, DefineAppContextOptions} from '../types';
import {defu} from 'defu';
import {clientFetch} from '../utils';

class AppContextOptionsInstance<TContext extends Partial<ContextDefault>, TEntries extends string[]>
    implements DefineAppContextOptions<TContext, TEntries>
{
    pinia!: Pinia;
    testing = false;
    public instances: Map<string, Required<AppContextInstance<TContext, TEntries>>> = new Map();

    addAppInstance(options: AppContextInstance<TContext, TEntries>) {
        const _defaultState = defu(options.defaultState, {
            _links: [],
            loading: false,
        }) as TContext;

        const id = options.id ?? options.useAppContext?.$id ?? `appContext${this.instances.size + 1}`;
        function createAppContext() {
            return defineStore(id, {
                state: () => ({..._defaultState} as unknown as TContext & {loading: boolean}),
            });
        }
        const createdInstance: Required<AppContextInstance<TContext, TEntries>> = {
            id,
            useAppContext: options.useAppContext ?? (createAppContext() as any),
            baseUrl: options.baseUrl,
            defaultState: _defaultState,
            entries: options.entries ?? ([] as any),
            onResolvedContext:
                options.onResolvedContext ??
                (async () => {
                    /** */
                }),
            $fetch: options.$fetch ?? clientFetch,
        };
        this.instances.set(id, createdInstance);
        return id;
    }

    updatePiniaInstance(_pinia: Pinia, testing?: boolean) {
        this.pinia = _pinia;
        if (testing) {
            this.testing = testing;
        }
    }
}

export const appContextOptions = new AppContextOptionsInstance();
